module.exports = __webpack_public_path__ + "img/sec2.4.8d6b8eac.png";